/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LegalPersonType = {
    Soletrader: 'SOLETRADER',
    Business: 'BUSINESS',
    Organization: 'ORGANIZATION',
    Partnership: 'PARTNERSHIP'
} as const;
export type LegalPersonType = typeof LegalPersonType[keyof typeof LegalPersonType];


export function instanceOfLegalPersonType(value: any): boolean {
    for (const key in LegalPersonType) {
        if (Object.prototype.hasOwnProperty.call(LegalPersonType, key)) {
            // @ts-ignore
            if (LegalPersonType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LegalPersonTypeFromJSON(json: any): LegalPersonType {
    return LegalPersonTypeFromJSONTyped(json, false);
}

export function LegalPersonTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalPersonType {
    return json as LegalPersonType;
}

export function LegalPersonTypeToJSON(value?: LegalPersonType | null): any {
    return value as any;
}

